import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom"; // Import useHistory
import {
  Card,
  CardBody,
  Container,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import toastr from "toastr";
import usePutAuthed from "../../helpers/hooks/usePutAuthed";

const ResetPassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));
  const history = useHistory();

  const [call, data, error, loading] = usePutAuthed(bankAdmin ? `change_password` : `user/change-password`, bankAdmin ? 'loan' : null);

  const handleReset = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toastr.error("Please fill out all fields.");
      return;
    }

    // if (newPassword.length < 6) {
    //   toastr.error("New password must be at least 6 characters long.");
    //   return;
    // }

    if (currentPassword === newPassword) {
      toastr.error("New password must be different from the current password.");
      return;
    }

    // Check if the new password and confirm password match
    if (newPassword !== confirmPassword) {
      toastr.error("New password and confirm password do not match.");
      return;
    }
    // Add logic to check if the current password matches the one stored in the database
    // You can replace this with your actual logic for checking passwords

    // const passwordMatches = checkPasswordInDatabase(currentPassword);

    // if (!passwordMatches) {
    //   toastr.error("Current password is incorrect. Please try again.");
    //   return;
    // }

    // console.log("Resetting password...");
    // console.log("Current Password:", currentPassword);
    // console.log("New Password:", newPassword);
    // console.log("Confirm Password:", confirmPassword);

    // Perform further actions such as updating the password in the database
    // resetPassword(newPassword);

    // setCurrentPassword("");
    // setNewPassword("");
    // setConfirmPassword("");

    // localStorage.removeItem("authUser");
    // localStorage.removeItem("loanAuth");
    // localStorage.removeItem("bankAdmin");
    // history.push("/login");
    // toastr.success("Password reset successfully!");

    const data = {
      currentPassword,
      newPassword,
      confirmPassword,
      // type: "ADMIN",
      email: bankAdmin ? bankAdmin.data.user.email :JSON.parse(localStorage.getItem("authUser")).data.user.email,
    };

    call(data);
  };

  useEffect(() => {
    if (data) {
      history.push(bankAdmin ? "/loan-list-bank" : "/login");
      toastr.success(data.msg)
    }
    if (error) {
      toastr.error("Something went wrong password not changed ");
    }
  }, [data]);

  const handleCancel = () => {
    history.push("/loan");
  };


  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

 

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h1 className="text-center">Reset Password</h1>
          <Card style={{ borderRadius: "20px" }}>
            <CardBody>
              <div
                style={{
                  border: "1px solid #ddd",
                  padding: "30px",
                  borderRadius: "10px",
                }}
              >
                <h2
                  style={{
                    fontWeight: "600",
                    marginBottom: "40px",
                  }}
                >
                  Set New Password
                </h2>
                <FormGroup>
                  <Label for="currentPassword">
                    <h5 style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                      Current Password
                    </h5>
                  </Label>

                  <Input
                    style={{
                      width: "500px",
                      padding: "25px",
                      borderRadius: "6px",
                    }}
                    type="password"
                    name="currentPassword"
                    id="currentPassword"
                    value={currentPassword}
                    placeholder="Enter current password"
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="newPassword">
                    <h5 style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                      New Password
                    </h5>
                  </Label>
                  <Input
                    style={{
                      width: "500px",
                      padding: "25px",
                      borderRadius: "6px",
                    }}
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    id="newPassword"
                    value={newPassword}
                    placeholder="Enter new password"
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <i
                    style={{
                      position: "absolute",
                      top: "52%",
                      transform: "translateY(-50%)",

                      marginLeft: "450px",
                      cursor: "pointer",
                    }}
                    onClick={toggleNewPasswordVisibility}
                    className={
                      showNewPassword ? "fas fa-eye" : "fas fa-eye-slash"
                    }
                  ></i>
                </FormGroup>
                <FormGroup>
                  <Label for="confirmPassword">
                    {" "}
                    <h5 style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                      Confirm Password
                    </h5>
                  </Label>

                  <Input
                    style={{
                      width: "500px",
                      padding: "25px",
                      borderRadius: "6px",
                    }}
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    id="confirmPassword"
                    value={confirmPassword}
                    placeholder="Re-Enter new password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <i
                    style={{
                      position: "absolute",
                      top: "70%",
                      transform: "translateY(-50%)",
                      marginLeft: "450px",
                      cursor: "pointer",
                    }}
                    onClick={toggleConfirmPasswordVisibility}
                    className={
                      showConfirmPassword ? "fas fa-eye" : "fas fa-eye-slash"
                    }
                  ></i>
                </FormGroup>
                <Button
                  onClick={handleCancel}
                  style={{
                    width: "180px",
                    borderRadius: "10px",
                    padding: "13px",
                    borderColor: "rgb(0,0,238)",
                    backgroundColor: "#fff",
                    marginTop: "28px",
                    marginRight: "15px",
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ color: "rgb(0,0,238)" }}>Cancel</span>
                </Button>{" "}
                <Button
                  onClick={handleReset}
                  style={{
                    width: "182px",
                    borderRadius: "10px",
                    padding: "13px",
                    backgroundColor: "rgb(0,0,238)",
                    borderColor: "rgb(0,0,238)",
                    marginTop: "28px",
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ color: "#fff" }}>Reset Password</span>
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
